const $ = window.jQuery

const updateHeight = () => {
  const $element = $('.viewer-main .slick-slide')

  $element.height('auto')
  let slideHeight = $('.viewer-main .slick-track').height()
  $element.css('height', slideHeight)
}

$(() => {
  const $viewerMain = $('.viewer-main')
  const $viewerNav = $('.viewer-nav')

  $viewerMain.on('init', () => {
    updateHeight()
    $(window).resize(updateHeight)
  })

  $viewerMain.on('beforeChange', () => {
    $('.slick-active').removeClass('slick-active')
  })

  $viewerMain.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
    infinite: false,
    asNavFor: '.viewer-nav'
  })

  $viewerNav.slick({
    centerMode: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: false,
    asNavFor: '.viewer-main',
    focusOnSelect: true,
    draggable: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  })
})
